//import {Chart} from 'chart.js/auto';
import { Chart, LineController, LineElement, PointElement, CategoryScale, LinearScale } from 'chart.js';
Chart.register(
    LineController,
    LineElement,
    PointElement,
    LinearScale,
    CategoryScale
    )

export const chartInvest = () => {
    const investItem = document.querySelectorAll('.invest__item-chart canvas');

    if (!investItem.length) return false;

    investItem.forEach(item => {
        if (item.classList.contains('done')) return false;
        const ctx = item.getContext('2d');
        const dataChart = item.getAttribute('data-chart').split(', ');

        let backgroundColor = '';
        let borderColor = '';

        if (item.classList.contains('c-green')) {
            backgroundColor = ctx.createLinearGradient(0, 0, 0, 100);
            backgroundColor.addColorStop(0, 'rgba(0, 159, 77, 0.4)');
            backgroundColor.addColorStop(0.4, 'rgba(0, 159, 77, 0)');
            borderColor = 'rgb(0, 159, 77)';
        }
        if (item.classList.contains('c-red')) {
            backgroundColor = ctx.createLinearGradient(0, 0, 0, 100);
            backgroundColor.addColorStop(0, 'rgba(171, 4, 13, 0)');
            backgroundColor.addColorStop(0.4, 'rgba(171, 4, 13, 0.4)');
            borderColor = 'rgb(171, 4, 13)';
        }

        const data = {
            labels: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
            datasets: [{
                borderColor,
                data: dataChart,
                fill: true,
                pointRadius: 0,
                backgroundColor,
            }]
        };
        const options = {
            scales: {
                x: {
                    display: false,
                },
                y: {
                    display: false,
                }
            },
            plugins: {
                legend: {
                    display: false,
                },
                tooltip: {
                    enabled: false
                }
            },
            responsive: true,
            maintainAspectRatio: false
        };
        const myChart = new Chart(ctx, {type: 'line', data, options});
        item.classList.add('done');
    });
};